import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Slider } from 'react-burgers';
import { setEnableClosedSidebar } from 'store/themeOptions/actions';
import AppMobileMenu from '../AppMobileMenu';
import logo from '../../assets/logo/myspy2.png';

const HeaderLogo = () => {
  const dispatch = useDispatch();
  const enableClosedSidebar = useSelector(
    state => state.themeOption.enableClosedSidebar
  );

  const [active, setActive] = useState(false);

  const toggleEnableClosedSidebar = () => {
    dispatch(setEnableClosedSidebar(!enableClosedSidebar));
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1024) {
        dispatch(setEnableClosedSidebar(true));
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [dispatch]);

  return (
    <>
      <div className="app-header__logo">
        {enableClosedSidebar !== true && (
          <span className="text-light">
            <img src={logo} alt="myspy" width={200} />
          </span>
        )}
        <div className="header__pane ms-auto">
          <div onClick={toggleEnableClosedSidebar}>
            <Slider
              active={enableClosedSidebar}
              type="elastic"
              onClick={() => setActive(!active)}
            />
          </div>
        </div>
      </div>
      <AppMobileMenu />
    </>
  );
};

export default HeaderLogo;
